import _ from 'lodash';
import './NodeEditCard.css';
import { connect } from 'react-redux';
import { editNode, closeSettingNewNodeNameCard, editingOn } from '../../stores/actions/adminActions';
import { Prompt } from 'react-router-dom';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import Download from '@material-ui/icons/CloudDownload';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import Loading from '../../components/Loading/Loading';
import React, { ChangeEvent } from 'react';
import TextField from '@material-ui/core/TextField';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import utils from '../../helpers/GlobalVariables';
import { INode } from '../../helpers/interfaces';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';

interface INodeEditCardProps {
	nodeID: number;
	name: string;
	nodeUpdatedAt: string;
	isEditing: boolean;
	nodes: INode[];
	settingNewNodeNameSuccess: boolean;
	settingNewNodeNameFailed: boolean;
	editingOn: (isEditing: boolean) => void;
	editNode: (nodeId: number, name: string, updatedAt: string) => void;
	closeSettingNewNodeNameCard: () => void;
	hideAlert: () => void;
}

interface INodeEditCardState {
	nodeID: number;
	name: string;
	nodeUpdatedAt: string;
	currentValue: string;
	error: boolean;
}

class NodeEditCard extends React.Component<INodeEditCardProps, INodeEditCardState> {
	state = {
		nodeID: this.props.nodeID,
		name: this.props.name,
		nodeUpdatedAt: this.props.nodeUpdatedAt,
		currentValue: this.props.name,
		error: false,
	};
	closeNotificationTimeout: ReturnType<typeof setTimeout> = null;

	componentWillMount() {
		onbeforeunload = (e) => "Don't leave";
	}

	componentDidMount() {
		this.props.closeSettingNewNodeNameCard();
	}

	componentDidUpdate() {
		const { settingNewNodeNameSuccess, settingNewNodeNameFailed, editingOn, closeSettingNewNodeNameCard, hideAlert } = this.props;
		if (settingNewNodeNameSuccess) {
			this.closeNotificationTimeout = setTimeout(() => {
				closeSettingNewNodeNameCard();
				hideAlert();
			}, 1000);
		}
		if (settingNewNodeNameFailed) {
			// editingOn(false);
			this.closeNotificationTimeout = setTimeout(() => {
				closeSettingNewNodeNameCard();
			}, 6000);
		}
	}

	componentWillUnmount() {
		onbeforeunload = null;
		clearTimeout(this.closeNotificationTimeout);
	}

	handleSetName = (): void => {
		const { currentValue, nodeID } = this.state;
		const { nodes } = this.props;

		const name = currentValue;
		const node = _.filter(nodes, { id: nodeID })[0];
		// TODO: pick one option to create updatedAt:
		// const updatedAt = node.updatedAt.slice(0, -1).replace('T', ' ');
		const updatedViaWebsiteAt = node.updatedViaWebsiteAt;
		this.props.editNode(nodeID, name, updatedViaWebsiteAt, node.systemId);
	};

	handleCurrentValueChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
		const currentValue = e.target.value;
		const containsIncorrectSigns = utils.validateInputChars(currentValue);

		this.setState({ currentValue: e.target.value, error: containsIncorrectSigns });

		if (this.props.settingNewNodeNameFailed) {
			this.props.closeSettingNewNodeNameCard();
		}
	};

	render() {
		const [node] = _.filter(this.props.nodes, { id: this.state.nodeID });
		const { error, currentValue } = this.state;
		const { settingNewNodeNameFailed, isEditing, hideAlert } = this.props;

		return (
			<>
				<Prompt when={true} message='Leaving the page now may result in the loss of unsaved data. Are you sure?' />
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button data-testid='cancelButton' simple justIcon color='info' style={closeSweetAlertStyle} onClick={hideAlert}>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>
				<Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<Download />
						</CardIcon>
						<h3 style={utils.sweetAlertHeaderStyle} className='node-edit-header'>
							Edit node's name
						</h3>
					</CardHeader>
					<CardBody>
						{node.SystemVersion === SYSTEM_VERSIONS.W2.valueOf() ? (
							<GridContainer>
								<GridItem xs={12}>
									<h5>This node is in WISENE W2 System. Name can be changed only trough W2 control panel.</h5>
								</GridItem>
								<GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
									<Button color='info' onClick={hideAlert} data-testid='closeAlertButton'>
										CLOSE
									</Button>
								</GridItem>
							</GridContainer>
						) : (
							<form>
								<GridContainer>
									<GridItem xs={12}>
										<TextField
											label='Name'
											id='name'
											value={currentValue}
											inputProps={{
												value: currentValue,
												maxLength: utils.defaultMaxInputLength,
												autoCapitalize: 'off',
											}}
											disabled={isEditing}
											placeholder={node.name}
											onChange={(e) => this.handleCurrentValueChange(e)}
											style={{ marginTop: '15px', width: '70%' }}
											error={error || settingNewNodeNameFailed}
											helperText={
												!settingNewNodeNameFailed
													? 'Incorrect name. Characters not allowed: <, >, /, \\, &, ; '
													: 'Invalid name or name already taken'
											}
											className={error || settingNewNodeNameFailed ? 'showAnimation' : ''}
										></TextField>
									</GridItem>
									<GridItem xs={12} style={{ margin: '15px 0 0 0 ' }}>
										<Button
											color={isEditing ? 'default' : 'info'}
											disabled={isEditing || error}
											onClick={this.handleSetName}
											data-testid='saveButton'
											style={{ transition: '0.3s' }}
										>
											{isEditing ? <Loading transform={0.9} width={28.906} height={17} color='gray' /> : 'SAVE'}
										</Button>
									</GridItem>
								</GridContainer>
							</form>
						)}
					</CardBody>
				</Card>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		nodes: state.dashboard.nodes,
		isEditing: state.dashboard.isEditing,
		settingNewNodeNameSuccess: state.dashboard.settingNewNodeNameSuccess,
		settingNewNodeNameFailed: state.dashboard.settingNewNodeNameFailed,
	};
};
const actions = { editNode, closeSettingNewNodeNameCard, editingOn };

export default connect(mapStateToProps, actions)(NodeEditCard);
